import React from "react";
import { Routes, Route } from "react-router-dom";

import NCPLayout from "./NCPLayout";
import Home from "../Pages/Home/Home";
import AboutUs from "../Pages/AboutUs/AboutUs";
import OurBoard from "../Pages/OurBoard";
import Publications from "../Pages/Publications/Publications";
// import YearBrochures from "../Pages/Publications/Brochures";
// import AnnualReports from "../Pages/Publications/AnnualReports";
// import Donate from "../Pages/Donate"; , Navigate, useLocation,useNavigate
// import Login from "../Pages/Login/Login";
import ContactUs from "../Pages/ContactUs";
const NCPRoutes = () => {
    return (<>
   <Routes>
        {/* Below is for home pages routes */}
        <Route path="/" element={<NCPLayout />}>
          <Route index element={<Home />} />
           <Route path="/AboutUs" element={<AboutUs />} />
           <Route path="/Our Board" element={<OurBoard />} />
          <Route path="/Publications" element={<Publications />} />
          {/* <Route path="/Donate" element={<Donate />} /> */}
          {/* <Route path="/Brochures" element={<YearBrochures />} /> */}
          {/* <Route path="/AnnualReports" element={<AnnualReports />} /> */}
          <Route path="/Contact Us" element={<ContactUs />} />
          {/* <Route path="/Login" element={<Login />} />  */}
        </Route>
        </Routes>
    </>)
}

export default NCPRoutes;